var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable, override } from 'mobx';
import { QuestionTypeLegacy } from '../../QuestionTypeLegacy';
export class ThinkAndRevealLegacy extends QuestionTypeLegacy {
    constructor(parent) {
        super(parent);
        makeObservable(this);
    }
    get legacyImagePlaces() {
        return [['question', this.questionPart.inner], ['solution', this.question.ownAspect.solution]];
    }
    get legacyCommentPlaces() {
        return [];
    }
    get evaltext() {
        return '';
    }
    set evaltext(evaltext) { }
}
__decorate([
    override
], ThinkAndRevealLegacy.prototype, "legacyImagePlaces", null);
__decorate([
    override
], ThinkAndRevealLegacy.prototype, "legacyCommentPlaces", null);
__decorate([
    computed
], ThinkAndRevealLegacy.prototype, "evaltext", null);
